import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { Editor, Text, Switch, Upload } from "components/fields";
import { Button, Spin2 } from "components";
import { createInfoProduct } from "../../actions";
import { validationSchemaInfo, initialValuesInfo } from "../components/common";
import { toastAlert } from "@paylixecommerce/shared/components";
import {useDispatch, useSelector} from "react-redux";

import "../components/style.scss";


const CreateInfoCard = () => {

	const history = useHistory();
	const dispatch = useDispatch();

	const [created, setCreated] = useState(false);


	const { profile } = useSelector(({ auth }) => auth);
	const isBusiness = profile && profile.subscription && (profile.subscription.id === 1 || profile.subscription.id === 5);

	const onSubmit = (values) => {

		setCreated(true);
		let data = {...values};

		data.unlisted = Boolean(values.unlisted);
		data.private = Boolean(values.private);

		dispatch(createInfoProduct(values))
			.then(res => {
				toastAlert('success', res.message);
				history.push('/products');
			})
			.catch(err => {
				toastAlert('error', err ? err.error : "");
			})
			.finally(() => {
				setCreated(false);
			})
	}

	let form = useFormik({
		validationSchema: validationSchemaInfo,
		enableReinitialize: true,
		initialValues: initialValuesInfo,
		onSubmit
	});

	return (
		<>

			<div className="edit-modal-header">
				<div className="edit-modal-header-title">New Info Card</div>
				<div className="edit-modal-header-ref" style={{ lineHeight: "1.5rem", marginTop: "1rem" }}>
					<div>You can mark this product as an info card: it will be shown in your shop as a basic card that cannot be purchased.</div>
					<div>This function can be used if you want to show your customers some info related to your shop or any other thing.</div>
					<div>Please note that even if they're considered products info cards cannot be transformed into normal products later on.</div>
				</div>
			</div>

			<div className="edit-modal-body">

				<form onSubmit={form.handleSubmit} className="product-form-main-back mb-0">
					<div>
						<Text label="Title" placeholder="Title" name="title" {...form} />
					</div>
					<div>
						<Editor label="Description" name="description" {...form} />
					</div>
					<div>
						<Upload isBusiness={isBusiness} name="image" {...form} label={<>Images&nbsp;<small>(optional)</small></>} />
					</div>
					<div className="mt-3 d-flex flex-wrap">
						<Switch name="unlisted" {...form} label="Unlisted" left note="The product wont be displayed on your Shop, but can still be accessed via direct URL." withBorder />
						<Switch name="private" {...form} label="Private" left note="This product will be removed from your shop and customers will not be able to use the direct link either."/>
					</div>
				</form>

			</div>

			<div className="edit-modal-footer">
				<Button type="button" size="large" disabled={created} variant="secondary" onClick={() => history.push('/products')}>
					Cancel
				</Button>
				<Button type="submit" size="large" iconName="plus" disabled={created} iconPosition="left" onClick={form.handleSubmit}>
					{created ? <Spin2 /> : 'Create Info Card'}
				</Button>
			</div>


		</>
	)
}

export default CreateInfoCard;
